import React from 'react';
import styled from 'astroturf/react';

import { currentUser } from 'js/utils/user';
import $image_url from 'js/utils/image_url';
import _PremiumLockImg from "PremiumLock-PremiumLockImg.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/premium/PremiumLock.tsx?styleId=PremiumLockImg";
import _PremiumLockSpan from "PremiumLock-PremiumLockSpan.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/premium/PremiumLock.tsx?styleId=PremiumLockSpan";


const DEFAULT_WIDTH = 22;

type Color = 'transparent' | 'gold' | 'blue' | 'white';

const getColor = (color: Color): string => {
  switch (color) {
    case 'transparent':
      return 'transparent';
    case 'gold':
      return 'var(--premium-dark, #877440)';
    case 'blue':
      return 'var(--primary-brand, #0645b1)';
    case 'white':
      return 'white';
    default: {
      const _exhaustiveCheck: never = color;
      return _exhaustiveCheck;
    }
  }
};

const PremiumLockImg = /*#__PURE__*/styled("img", null, {
  displayName: "PremiumLockImg",
  styles: _PremiumLockImg
});

const PremiumLockSpan = /*#__PURE__*/styled("span", null, {
  displayName: "PremiumLockSpan",
  styles: _PremiumLockSpan
});

type Props = {
  width?: number;
  circleColor?: Color;
  lockColor?: Color;
};

const PremiumLock = ({
  width = DEFAULT_WIDTH,
  circleColor = 'transparent',
  lockColor = 'gold',
}: Props) => {
  if (currentUser?.premium) {
    return null;
  } else {
    if (lockColor === 'transparent') {
      let src: string;
      switch (circleColor) {
        case 'white':
          src = $image_url('premium/Lock-CircleWhite-Transparent.svg');
          break;
        case 'gold':
          src = $image_url('premium/Lock-CircleGold-Transparent.svg');
          break;
        case 'blue':
          src = $image_url('premium/Lock-CircleBlue-Transparent.svg');
          break;
        case 'transparent':
          throw new Error(
            'Circle color cannot be transparent when lock color is transparent',
          );
        default:
          throw new Error(`Invalid circle color: ${circleColor}`);
      }

      return (
        <PremiumLockImg
          src={src}
          alt="lock"
          style={
            {
              '--pl-size': `${width}px`,
              '--pl-circle': getColor(circleColor),
            } as React.CSSProperties
          }
        />
      );
    } else {
      return (
        <PremiumLockSpan
          aria-hidden="true"
          style={
            {
              '--pl-size': `${width}px`,
              '--pl-circle': getColor(circleColor),
              '--pl-lock': getColor(lockColor),
              '--pl-mask': `url("${$image_url('premium/lock-mask.svg')}") center / contain no-repeat`,
            } as React.CSSProperties
          }
        />
      );
    }
  }
};

export default PremiumLock;
